import React from 'react'
import classNames from 'classnames'

import { Body1 } from 'pharmacy/src/typography'
import { Checkbox } from 'pharmacy/src/input/checkbox'

import css from './topicCheckbox.scss'

export default function TopicCheckbox({ topic, checked, onChange, className }) {
  const containerClasses = classNames(css.container, className)
  const labelClasses = classNames(css.topicLabel, {
    [css.checked]: checked,
  })

  return (
    <label className={containerClasses}>
      <Checkbox checked={checked} onChange={onChange} />
      <Body1 className={labelClasses}>{topic.topic}</Body1>
    </label>
  )
}
